import { createFeatureSelector, createSelector } from '@ngrx/store';

import { PaymentScheduleStatusType } from '@amfam/shared/models';

import { ReplaceVehicleDataState } from '..';
import { QuickQuoteDataState } from './quick-quote-data.reducer';

const getReplaceVehicleDataState =
  createFeatureSelector<ReplaceVehicleDataState>('replace-vehicle-data');

const getQuickQuoteState = createSelector(getReplaceVehicleDataState, state => state.quickQuote);

export const getLoading = createSelector(
  getQuickQuoteState,
  (state: QuickQuoteDataState) => state.loading
);

export const getLoaded = createSelector(
  getQuickQuoteState,
  (state: QuickQuoteDataState) => state.loaded
);

export const getQuickQuotePremium = createSelector(getQuickQuoteState, state => state.premium);

export const getWorkOrderNumber = createSelector(
  getQuickQuotePremium,
  premium => premium?.workOrderNumber || ''
);

export const errorOnQuickQuote = createSelector(getQuickQuoteState, state => state.error);

export const errorOnANS = createSelector(getQuickQuoteState, state => state.ansError);

export const errorOnExceptionANS = createSelector(
  getQuickQuoteState,
  state => state.exceptionAnsError
);

export const errorOnQuickQuoteANS = createSelector(
  errorOnQuickQuote,
  errorOnANS,
  (quickQuoteError: boolean, ansError: boolean) => quickQuoteError || ansError
);

export const getFuturePayments = createSelector(getQuickQuoteState, state =>
  state?.paymentSchedule?.filter(
    p => p.estPaymentAmount > 0 && p.status === PaymentScheduleStatusType.PLANNED
  )
);

export const quickQuoteDataQuery = {
  getQuickQuoteState,
  getLoading,
  getLoaded,
  getQuickQuotePremium,
  getWorkOrderNumber,
  errorOnQuickQuote,
  errorOnANS,
  errorOnExceptionANS,
  errorOnQuickQuoteANS,
  getFuturePayments
};
